import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG, WS_ENDPOINT_URL } from "./configs/AppConfig";
import "./lang";
import { enablePushForAdmin } from "utils/pushFunction";
import PushNavListener from "PushNavListener";
import AdminWsListener from "AdminWsListener";
import { AdminNotificationsProvider } from "contexts/AdminNotificationsContext";
import { PermissionProvider } from "contexts/PermissionContext";
import { API_BASE_URL } from "constants/ApiConstant";
// import AdminWsBridge from "AdminWsBridge";
// import { DataProvider } from "contexts/DataProvider";
// import { WebSocketProvider } from "contexts/WebSocketProvider";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  useEffect(() => {
    // ✅ keep auto-enable for desktop
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (!isIOS) {
      enablePushForAdmin().catch(console.error);
    }
  }, []);


  // useEffect(() => {
  //   const preventZoom = (event) => {
  //     if (event.ctrlKey || event.touches?.length > 1) {
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener("wheel", preventZoom, { passive: false });
  //   document.addEventListener("keydown", (event) => {
  //     if (event.ctrlKey && (event.key === "+" || event.key === "-")) {
  //       event.preventDefault();
  //     }
  //   });
  //   document.addEventListener("touchmove", preventZoom, { passive: false });

  //   return () => {
  //     document.removeEventListener("wheel", preventZoom);
  //     document.removeEventListener("keydown", preventZoom);
  //     document.removeEventListener("touchmove", preventZoom);
  //   };
  // }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <PermissionProvider>
            <AdminNotificationsProvider>
              {/* ✅ NOW it can read context */}
              <AdminWsListener />

              <PushNavListener />
              <ThemeSwitcherProvider
                themeMap={themes}
                defaultTheme={THEME_CONFIG.currentTheme}
                insertionPoint="styles-insertion-point"
              >
                <Layouts />
              </ThemeSwitcherProvider>
            </AdminNotificationsProvider>
          </PermissionProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
